(function (module) {

    module.service('marketDefinitionService', ['$http', marketDefinitionService])

    function marketDefinitionService(this: $TSFixMe, $http: ng.IHttpService) {
        var service = this;

        service.get = () => {
            return $http.get('/api/market-definition')
                .then(function (response: $TSFixMe) {
                    return response.data;
                });
        };

        service.getActive = () => {
            return $http.get('/api/market-definition', {
                params: { isActive: true }
            }).then((response: $TSFixMe) => response.data);
        };

        service.edit = (entity: $TSFixMe) => {
            return $http.post('api/market-definition', entity);
        };

        service.add = (entity: $TSFixMe) => {
            return $http.put('api/market-definition', entity);
        };

        service.toggleActivity = (entity: $TSFixMe) => {
            return $http.post(`/api/market-definition/${entity.id}/toggle-activity`, null)
                .then(function (response: $TSFixMe) { return response.data; });
        };

    }

})(angular.module('topline.modules'));